"use client"
import Image from "next/image"
import Link from "next/link"
import { CustomerNumberCopy } from "./customer-number-copy.tsx"
import type { MyLegalDocuments } from "./my-legal-dialogs.tsx"
import { MyLegalDialogs } from "./my-legal-dialogs.tsx"

const linkGroups = [
  {
    id: "account",
    links: [
      { href: "/my/phone", label: "휴대전화 관리" },
      { href: "/my/delete-account", label: "계정 삭제 안내" },
    ],
    title: "계정",
  },
  {
    id: "usage",
    links: [
      { href: "/orders", label: "주문 내역" },
      { href: "/vouchers", label: "내 상품권" },
    ],
    title: "이용 내역",
  },
  {
    id: "notifications",
    links: [
      { href: "/notifications", label: "알림" },
      { href: "/my/preferences", label: "환경 설정" },
    ],
    title: "알림 및 설정",
  },
  {
    id: "support-security",
    links: [{ href: "/support/inquiries", label: "고객지원" }],
    title: "지원 및 보안",
  },
] as const
export type MyLinkGroupsProps = {
  readonly details?: readonly {
    readonly label: string
    readonly value: string
  }[]
  readonly legalDocuments?: MyLegalDocuments
}
export const MyLinkGroups = ({ details = [], legalDocuments }: MyLinkGroupsProps) => {
  const customerNumber = details.find(({ label }) => label === "고객번호")?.value
  return (
    <nav aria-label="내 정보 바로가기" className="redesign-my-layout">
      <header className="redesign-my-profile">
        {customerNumber === undefined ? null : (
          <div className="redesign-my-customer">
            <span>고객 번호</span>
            <CustomerNumberCopy presentation="text" value={customerNumber} />
          </div>
        )}
      </header>
      <div className="redesign-my-menu-groups">
        {linkGroups.map((group) => (
          <section className="redesign-my-menu-group" data-my-link-group={group.id} key={group.id}>
            <h2 data-my-group-title>{group.title}</h2>
            <ul>
              {group.links.map((link) => (
                <li key={link.href}>
                  <Link data-destructive={link.href === "/my/delete-account" || undefined} href={link.href}>
                    <span>{link.label}</span>
                    <Image alt="" height={16} src="/assets/cashhub/redesign/account-chevron.svg" width={16} />
                  </Link>
                </li>
              ))}
              {group.id === "support-security" && legalDocuments !== undefined ? <MyLegalDialogs documents={legalDocuments} /> : null}
            </ul>
          </section>
        ))}
      </div>
    </nav>
  )
}
